import React from "react";

export default function WebViewWompi({ url }) {
  const iframeRef = React.useRef(null);

  return (
    <div className="p-2 lg:p-8" style={{ height: 500 }}>
      <iframe
        id="wompi_pse_iframe"
        ref={iframeRef}
        src={url}
        width="100%"
        height="100%"
        style={{ border: "none", marginTop: "30px" }}
        title='Wompi PSE'
      />
    </div>
  );
}